<template>
  <Dialog
    v-model:visible="localVisible"
    modal
    maximizable
    :closeOnEscape="false"
    ref="dialogRef"
    :style="{ width: '100vw' }"
    @update:visible="handleDialogClose"
  >
    <!-- display breadcrumb only if page.list_items is not empty -->
    <div
      v-if="page && page.list_items && page.list_items.length > 0"
      class="px-2"
    >
      <Breadcrumb
        :home="homeBreadcrumbItem"
        :model="breadcrumbItems"
      >
        <template #item="{ item, props }">
          <router-link
            custom
            :to="item.route || ''"
          >
            <p
              v-bind="props.action"
              @click="navigateToPageInTheBreadcrumb(item.id)"
              class="cursor-pointer"
            >
              <span :class="[item.icon, 'text-color']" />
              <span
                :class="[
                  page.id === item.id ? 'text-primary' : '',
                  'font-semibold text-sm'
                ]"
              >
                {{ item.label }}
              </span>
            </p>
          </router-link>
        </template>
      </Breadcrumb>
    </div>

    <template
      #header
      class="flex items-center justify-center"
    >
      <div class="flex items-center">
        <span class="font-bold text-2xl text-surface-950">{{ title }}</span>
        <div
          class="text-md text-gray-500 px-2"
          v-if="Helper.isValueExist(page.min_required_items) && page.is_list"
        >
          {{ `(${page.list_items.length}/${page.min_required_items})` }}
        </div>
      </div>
    </template>

    <div class="overflow-y-auto pb-16">
      <!-- Page Content -->
      <component
        v-if="page.pageObj && !page.is_list"
        :is="'PageBuilderComponent'"
        :page="page"
        :selectedPath="selectedPath"
        :selectedLabels="selectedLabels"
        :savedResValue="savedResValue"
        :ignoreOverridePageValue="ignoreOverridePageValue"
        :updateLocalStore="updateLocalStore"
        @update:page="onUpdatePage"
      />
      <div v-if="page.is_list">
        <div
          class="flex justify-end pb-2"
          v-if="page.show_add_new != false"
        >
          <Button
            label="New Form"
            icon="pi pi-plus"
            severity="success"
            @click="onAddNewForm"
          />
        </div>
        <div
          v-if="
            page.template_type ==
            Constants.enums.PAGE_TEMPLATE_TYPE.PROCEDURES_LIST
          "
        >
          <div
            v-for="(item, _i) in page.list_items"
            :key="_i"
            class="pb-4"
          >
            <component
              v-if="item"
              :is="'ProceduresTemplateComponent'"
              :showCRUDOptions="
                page.show_add_new == false ? page.show_add_new : true
              "
              @update:navigateToBreadcrumb="navigateToPageInTheBreadcrumb"
              :pageData="item"
              :selectedPath="getUniquePath([...selectedPath, page.id])"
              :selectedLabels="
                getUniqueLabels([
                  ...selectedLabels,
                  { label: page.label, id: page.id }
                ])
              "
              :parentPageData="page.pageObj"
              @update:parentPageData="
                (data) => onUpdateParentPageData(_i, data)
              "
              :resId="route.params.res || null"
              status="test"
              :savedResValue="savedResValue"
              :onDeleteItem="
                () => {
                  confDialog.selectedItemIndex = _i;
                  confDialog.isVisible = true;
                }
              "
            />
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div
        class="pt-3"
        v-if="page.pageObj && !page.is_list"
      >
        <!-- Buttons -->
        <div
          class="flex pt-6 justify-end"
          v-if="page.hover_btns"
        >
          <!-- Left Buttons -->
          <div
            class="fixed bottom-4 left-5"
            v-if="page.hover_btns.left && page.hover_btns.left.length"
          >
            <div
              v-for="(button, index) in page.hover_btns.left"
              :key="index"
            >
              <Button
                :label="button.label || ''"
                :severity="button.severity"
                :icon="button.icon || ''"
                @click="onNavigationBtnClick(button.onClick)"
              />
            </div>
          </div>
          <!-- Right Buttons -->
          <div
            class="fixed bottom-4 right-5"
            v-if="page.hover_btns.right && page.hover_btns.right.length"
          >
            <Button
              v-for="(button, index) in page.hover_btns.right"
              :key="index"
              :label="button.label || ''"
              :severity="button.severity"
              :icon="button.icon || ''"
              class="ml-3"
              @click="onNavigationBtnClick(button.onClick)"
            />
          </div>
        </div>
      </div>
      <!-- if it's add form -->
      <div
        class="flex justify-end gap-2 pt-3"
        v-if="onSaveClick"
      >
        <Button
          type="button"
          label="Cancel"
          icon="pi pi-times"
          severity="secondary"
          @click="localVisible = false"
        ></Button>
        <Button
          type="button"
          label="Save"
          icon="pi pi-check"
          severity="contrast"
          @click="onSavingData(page)"
        ></Button>
      </div>
    </template>
  </Dialog>
  <!-- New form component -->
  <Dialog
    v-model:visible="addMoreFormIsvisible"
    header="+ New Form"
    modal
    :closable="false"
    maximizable
    :style="{ width: '50rem' }"
    :breakpoints="{ '1199px': '70vw', '575px': '90vw' }"
  >
    <div class="overflow-y-auto pb-16">
      <!-- Page Content -->
      <component
        v-if="page.pageObj && page.is_list"
        :is="'PageBuilderComponent'"
        :page="page"
        :selectedPath="[...selectedPath, page.id]"
        :selectedLabels="[...selectedLabels, [page.label, page.id]]"
        :savedResValue="savedResValue"
        @update:page="onUpdatePage"
        :updateLocalStore="false"
        :ignoreOverridePageValue="ignoreOverridePageValue"
      />
    </div>
    <template #footer>
      <div class="flex justify-end gap-2 pt-3">
        <Button
          type="button"
          label="Cancel"
          icon="pi pi-times"
          severity="secondary"
          @click="addMoreFormIsvisible = false"
        ></Button>
        <Button
          type="button"
          label="Save"
          icon="pi pi-check"
          severity="contrast"
          @click="onAddNewSaveBtnClick"
        ></Button>
      </div>
    </template>
  </Dialog>
  <!-- Error Dialog Component -->
  <component
    :is="'ErrorDialog'"
    :visible="errorObj.isVisible"
    :message="errorObj.errorMsg"
    :onConfirm="onErrorDialogClose"
    @update:visible="errorObj.isVisible = $event"
  />
  <component
    :is="'ConfirmationDialog'"
    :visible="confDialog.isVisible"
    :message="confDialog.msg"
    :headerMsg="confDialog.headerMsg"
    :onConfirm="confDialog.onConfirm"
    @update:visible="confDialog.isVisible = $event"
  />
</template>

<script>
  import { defineComponent, ref, watch, onMounted, computed } from "vue";
  import Constants from "@/utils/constants";

  import Helper from "@/utils/helper";
  import { useRoute, useRouter } from "vue-router";
  import { useFormPageStore } from "@/stores/formPageStore";
  import { useFormTemplateResponseStore } from "@/stores/formTemplateResponseStore";
  import { storeToRefs } from "pinia";

  export default defineComponent({
    name: "FormPageDialogComponent",
    props: {
      page: {
        type: Object,
        required: true
      },
      title: {
        type: String,
        default: ""
      },
      visible: {
        type: Boolean,
        required: true
      },
      isFullScreen: {
        type: Boolean,
        default: true
      },
      onSaveClick: {
        type: Function
      },
      selectedPath: {
        type: Array,
        default: () => []
      },
      savedResValue: {
        type: Object,
        required: false,
        default: () => ({})
      },
      selectedLabels: {
        type: Array,
        default: () => []
      },
      ignoreOverridePageValue: {
        type: Boolean,
        default: false
      },
      itemId: {
        type: String,
        default: null
      },
      updateLocalStore: {
        type: Boolean,
        default: true
      }
    },
    setup(props, { emit }) {
      const formTemplateResponseStore = useFormTemplateResponseStore();
      const { response } = storeToRefs(formTemplateResponseStore);
      const localVisible = ref(props.visible);
      const dialogRef = ref(null);
      const route = useRoute();
      const router = useRouter();
      const addMoreFormIsvisible = ref(false);
      const errorObj = ref({
        isVisible: false,
        errorMsg: ""
      });
      let updatedPageData = props.page;
      let initialPageData = null;
      if (!props.page.is_list) {
        // if it's not list then store initial value
        const _parentPageId = props.selectedPath[props.selectedPath.length - 1];
        initialPageData = Helper.findAndSetKeyInObject(
          Helper.deepCopy(response.value),
          _parentPageId
        );
      }

      const updateResponseStoreData = async (data, removeId) => {
        let _parentPageId = props.selectedPath[props.selectedPath.length - 1];
        const _currentPageData = Helper.findAndSetKeyInObject(
          Helper.deepCopy(response.value),
          _parentPageId
        );
        if (!removeId) {
          // if no index then we need to push data to the list
          // if already exists then push the new item to the list
          // check if the data is already exists in the template list
          const templateListKey = `${_parentPageId}_list_items`;
          const existingIndexInListItems = _currentPageData[
            templateListKey
          ]?.findIndex((item) => item.id === data.id);
          if (existingIndexInListItems !== -1) {
            // if already exists then update the existing record
            const _existingRecord =
              _currentPageData[templateListKey][existingIndexInListItems];
            _currentPageData[templateListKey][existingIndexInListItems] = {
              ..._existingRecord,
              ...data
            };
          } else {
            if (_currentPageData.list_items) {
              // finding index
              const existingItemIndex = _currentPageData.list_items.findIndex(
                (item) => item.id === data.id
              );
              // if -1 then no data found, so we need to push the data to the list
              if (existingItemIndex !== -1) {
                // pull existing record
                const _existingRecord =
                  _currentPageData.list_items[existingItemIndex];
                // merge the existing record with the new data
                _currentPageData.list_items[existingItemIndex] = {
                  ..._existingRecord,
                  ...data
                };
              } else {
                _currentPageData.list_items.push(data);
              }
            } else {
              _currentPageData.list_items = [data];
            }
          }
        } else if (removeId != null) {
          // first make sure we mimi the obj that we've in the ui
          if (_currentPageData.list_items) {
            // remove the item based on existing id from the list
            _currentPageData.list_items = _currentPageData.list_items.filter(
              (item) => item.id !== removeId
            );
          }
        }
        // update the local store with the new list item data, so that it can be saved to the database on final save
        formTemplateResponseStore.setResponse(_parentPageId, _currentPageData);
      };

      const onDeleteItem = async (index) => {
        updateResponseStoreData(null, props.page.list_items[index].id);
        // to update the ui
        props.page.list_items.splice(index, 1);
      };

      const confDialog = ref({
        isVisible: false,
        msg: "Are you sure you would like to delete selected item 123?",
        headerMsg: "Delete Confirmation!",
        selectedItemIndex: 0,
        onConfirm: () => onDeleteItem(confDialog.value.selectedItemIndex)
      });

      const onErrorDialogClose = () => {
        errorObj.value.isVisible = false;
        errorObj.value.errorMsg = "";
      };

      // Watch for visibility changes from parent to keep local state in sync
      watch(
        () => props.visible,
        (newVal) => {
          localVisible.value = newVal;
        }
      );

      onMounted(() => {
        if (props.isFullScreen) dialogRef.value.maximized = true;
      }),
        // Watch for changes to localVisible to emit updates to the parent
        watch(localVisible, (newVal) => {
          emit("update:visible", newVal); // Emit the updated value to the parent
        });

      const onNavigationBtnClick = async (type) => {
        switch (type) {
          case Constants.enums.NAVIGATION_BTN_ACTIONS.ON_SAVE:
            // calling this to function get the progress data
            await useFormPageStore().updateFormPageFromList(updatedPageData);
            await saveFormResponse();
            localVisible.value = false;
            break;
          case Constants.enums.NAVIGATION_BTN_ACTIONS.ON_CANCEL:
            // on cancel we want to purge the new changes that user may have done in the form
            if (!props.page.is_list) {
              // on cancel reset the response to initial value
              formTemplateResponseStore.setResponse(
                props.page.id,
                initialPageData
              );
            }
            break;
          default:
            break;
        }
      };

      const onUpdatePage = async (data) => {
        // console.log("onUpdatePage :", data);
        updatedPageData = data;
      };
      const onAddNewSaveBtnClick = async () => {
        try {
          const _parentPageId =
            props.selectedPath[props.selectedPath.length - 1];
          let _newDataObj = updatedPageData?.pageObj?.fields
            ? {
                id: Helper.getRandomUuid(),
                ...updatedPageData.list_item_template,
                ...(Helper.processFieldValues(updatedPageData.pageObj.fields) ||
                  {})
              }
            : null;
          if (_newDataObj) {
            updatedPageData.list_items.push(_newDataObj);
          }
          updateResponseStoreData(_newDataObj, null);
          emit("update:page", updatedPageData);
          await saveFormResponse();
          Helper.showToast("Successful", "Form Added Successfully");
          // print this after 2 sec
          setTimeout(() => {
            console.log(
              "UPDATED RESPONSE :",
              `${_parentPageId}_list_items :`,
              response.value
            );
          }, 2000);
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
        } finally {
          addMoreFormIsvisible.value = false;
        }
      };

      const onSavingData = async (val) => {
        let _resObj = Helper.processFieldValues(val.pageObj.fields) || {};
        _resObj.id = props.itemId;
        updateResponseStoreData(_resObj, null);
        await props.onSaveClick(_resObj);
        emit("update:page", val);
        Helper.showToast("Successful", "Form Updated Successfully");
        localVisible.value = false;
      };

      const onUpdateParentPageData = async (itemIndex, data) => {
        let _temp = Helper.deepCopy(props.page);
        _temp.list_items[itemIndex] = {
          ..._temp.list_items[itemIndex],
          ...data
        };
        emit("update:page", _temp);
      };

      const onAddNewForm = () => {
        addMoreFormIsvisible.value = true;
        // to update the UI
        props.page.pageObj.fields = Helper.processFieldValues(
          Helper.deepCopy(props.page.pageObj.fields),
          {}
        );
      };

      const getUniquePath = (pathArray) => {
        return pathArray.filter(
          (id, index, array) => array.indexOf(id) === index
        );
      };
      const getUniqueLabels = (labelsArray) => {
        return labelsArray.filter((item, index, array) => {
          const id = Array.isArray(item) ? item[1] : item.id;
          return (
            array.findIndex((t) => (Array.isArray(t) ? t[1] : t.id) === id) ===
            index
          );
        });
      };
      const handleDialogClose = (value) => {
        console.log("HANDLE DIALOG CLOSE -----> :", value);
        // when user clicks on close button, we want to cancel the changes that user may have done in the form
        if (!value) {
          onNavigationBtnClick(
            Constants.enums.NAVIGATION_BTN_ACTIONS.ON_CANCEL
          );
        }
      };

      async function saveFormResponse() {
        try {
          // check if the form is new or not
          const isNewForm = !route.params.res;

          const result = await Helper.saveFormResponse({
            createNew: isNewForm,
            customResponse: null,
            isEmbedded: false,
            response: formTemplateResponseStore.response,
            formProgress: useFormPageStore().formProgress,
            formId: route.params.id || route.params.formId,
            responseId: route.params.res,
            formTemplateResponseStore: formTemplateResponseStore,
            formTemplateResponse: formTemplateResponseStore.response,
            shouldShowToast: true
          });

          // if the form is new, set the route parameter
          if (isNewForm && result) {
            const newResponseId =
              typeof result === "string" ? result : result.id;
            console.log("newResponseId", newResponseId);
            if (newResponseId) {
              router.push({
                path: `/admin/form-template/${route.params.id}/${newResponseId}`,
                replace: true
              });
            }
          }

          return result;
        } catch (error) {
          errorObj.value.isVisible = true;
          errorObj.value.errorMsg = error;
          throw error;
        }
      }

      const homeBreadcrumbItem = ref({
        icon: "pi pi-home",
        id: ""
      });

      const breadcrumbItems = computed(() => {
        return props.selectedLabels?.map((item) => item) ?? [];
      });

      const navigateToPageInTheBreadcrumb = async (targetPageId) => {
        // current page id
        const _currentPageId = props.page.id;
        if (targetPageId !== _currentPageId) {
          onNavigationBtnClick(
            Constants.enums.NAVIGATION_BTN_ACTIONS.ON_CANCEL
          );
          // wait for 100 ms
          await new Promise((resolve) => setTimeout(resolve, 100));
          emit("update:navigateToBreadcrumb", targetPageId);
        }
      };

      return {
        Helper,
        route,
        Constants,
        localVisible,
        dialogRef,
        errorObj,
        confDialog,
        onErrorDialogClose,
        addMoreFormIsvisible,
        onAddNewForm,
        onNavigationBtnClick,
        onAddNewSaveBtnClick,
        onSavingData,
        onUpdatePage,
        onUpdateParentPageData,
        onDeleteItem,
        response,
        getUniquePath,
        navigateToPageInTheBreadcrumb,
        handleDialogClose,
        homeBreadcrumbItem,
        breadcrumbItems,
        getUniqueLabels
      };
    }
  });
</script>
